export const replaceUrlParamVal = (paramName, replaceWith, url = window.location.href) => {
    let re = new RegExp(`(${paramName}=)([^&]*)`, "ig");
    const result = url.replace(re, `${paramName}=${replaceWith}`);
    re = null;
    return result;
};
